import $i18n from '@/modules/FPKG-20000-Util/lang';

const login = {
  username: {
    id: 'username',
    rule: [
      {
        required: true,
        message: $i18n.t('Account.ruleName'),
      },
    ],
  },
  password: {
    id: 'password',
    rule: [
      {
        required: true,
        message: $i18n.t('Account.rulePass'),
      },
    ],
  },
  captcha: {
    id: 'captcha',
    rule: [
      {
        required: true,
        message: $i18n.t('Account.ruleCaptcha'),
      },
    ],
  },
  GoogleMFA: {
    id: 'google_mfa_code',
    rule: [
      {
        required: true,
        message: 'Google Code',
      },
    ],
  },
};

export default login;
